import { FC } from "react";
import { Box, Typography } from "@material-ui/core";

import { Modal } from "components";
import { formatHumanDate } from "lib/format";
import { ResaleInfo } from "services/listings/types";

import ROITable from "./ROITable";

interface ROIModalProps {
  open: boolean;
  onClose: () => void;
  resaleInfo: ResaleInfo;
  currency: string;
}

const ROIModal: FC<ROIModalProps> = props => (
  <Modal title="Returns Information" open={props.open} onClose={props.onClose}>
    <ROITable resaleInfo={props.resaleInfo} />
    <Typography color="textSecondary" component="div" variant="subtitle1">
      <Box mb={4} fontStyle="italic" my={2}>
        {`Last updated ${formatHumanDate(props.resaleInfo.last_update)}`}
      </Box>
    </Typography>
  </Modal>
);

export default ROIModal;
